<template>
<!-- eslint-disable max-len -->
<header ref="header" style="display: flex; flex-direction: column;">
  <nav
    class="navbar navbar-expand-lg navbar-root"
    :class="{ 'centered-title': forceCenteredTitle }"
    :style="`border-bottom: 1px solid ${activeEnvironment.primaryColor || 'white'}; background-color: ${activeEnvironment.navBarColor || 'rgba(17, 17, 17, 1);'}`"
    ref="navbarRoot"
  >
    <!-- <a href="" class="navbar-brand" @click.prevent="onClickBrand">{{ activeEnvironment.brand || brand }}</a> -->
    <div
      class="navbar-logo"
      :class="{ 'centered-title': forceCenteredTitle }"
      style="display: flex; flex-direction: row;"
    >
      <a href="" class="logo-link" @click.prevent="onClickBrand">
        <img :src="resolveAssetPath(navbarLogo, 'ui/customer')" class="logo">
      </a>
      <!-- <div class="navbar-item-divider" style="height: 90%; margin-top: 2px; margin-right: 7px;"/> -->
    </div>

    <span
      v-if="hasAuthToken"
      class="navbar-brandText noselect"
      :class="{ 'centered-title': forceCenteredTitle }"
      @dblclick.prevent="toggleFullscreen"
      v-html="activeEnvironment.brand || brand"
    ></span>

    <button
      ref="toggler"
      @click="toggleNavbar"
      class="navbar-toggler navbar-toggler-right"
      style="margin-left: calc(33% - 56px);"
      type="button"
      data-toggle="collapse"
      data-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent"
      aria-expanded="false"
      aria-label="Toggle navigation"
      :style="{
        visibility: (!authToken || (me.eulaAccepted || isLti)) ? undefined : 'hidden',
      }"
    >
      <span class="navbar-toggler-icon">
        <i
          class="fas fa-bars"
          :style="{
            color: (activeEnvironment.primaryColor || 'white'),
            'font-size': '28px',
          }"
        ></i>
      </span>
    </button>

    <div
      ref="togglee"
      class="collapse navbar-collapse navbar-actionItems"
      :class="{ 'centered-title': forceCenteredTitle }"
      id="navbarSupportedContent"
    >
      <ul v-if="!authToken || (me.eulaAccepted || isLti)" class="navbar-nav ml-auto" style="align-items: center;">
        <li class="nav-item active" v-if="shouldDisplayAssetEnvironmentSelector">
          <active-asset-environment-selector />
        </li>
        <save-state-selector v-if="shouldDisplaySaveStateSelector" />
        <li class="nav-item active" v-if="false">
          <a href="" @click.prevent="onClickBrand" class="nav-link">My Gamulations</a>
        </li>
        <li v-if="(isDemoOrGameRoute && canRestartGame) || (!isDemoOrGameRoute && canViewDemo)">
          <div class="navbar-item-divider" style="margin-left: 7px;"/>
        </li>
        <li v-if="isDemoOrGameRoute && canRestartGame && !shouldDisplayHubButton" class="nav-item active">
          <a href="" @click.prevent="restartDemo" class="nav-link">Restart</a>
        </li>
        <li v-if="!isDemoOrGameRoute && canViewDemo && !shouldDisplayHubButton" class="nav-item active">
          <router-link to="/demo" class="nav-link">Start</router-link>
        </li>
        <li v-if="shouldDisplayHubButton" class="nav-item active">
          <!-- <a href="/hub" class="nav-link">Gamulations and {{classTypeNamePlural}}</a> -->
          <a href="/hub" class="nav-link">Home Page</a>
        </li>
        <li v-if="shouldDisplayDashboardLink" class="nav-item active">
          <a :href="activeDashboardLink" target="_blank" class="nav-link">Dashboards</a>
        </li>
        <!-- <li v-if="isProfessor && !isManager">
          <div class="navbar-item-divider"/>
        </li>
        <li v-if="isProfessor && !isManager" class="nav-item active">
          <router-link v-if="isLti" to="/blade/classes" class="nav-link">Manage {{classTypeNamePlural}}</router-link>
          <a v-else href="/blade/classes" target="_blank" class="nav-link">Manage {{classTypeNamePlural}}</a>
        </li> -->
        <!-- TODO: add separate permission and get rid of isManager check -->
        <li v-if="(canManageGames || canManageUsers || canGenerateReports || isManager) && showAdmin">
          <div class="navbar-item-divider"/>
        </li>
        <li v-if="(canManageGames || canManageUsers || canGenerateReports || isManager) && showAdmin" class="nav-item dropdown active">
          <a
            class="nav-link dropdown-toggle"
            href="#"
            id="gameConfigMenu"
            role="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false">
            Admin
          </a>
          <div class="dropdown-menu navbar-bg" aria-labelledby="gameConfigMenu">
            <div v-if="canManageUsers">
              <navbar-link href="/blade/domainbrandings" target="_blank" class="dropdown-item">Domain Brandings</navbar-link>
              <div
                v-if="canManageDashboards || canManageGameSets || canManageGames || canManageGameInvites || canManageEnvironments
                  || canManageUsers || canManageAllGroups || canManageGameSets || canManageDashboards || canGenerateReports
                  || (canViewDashboards && activeEnvironment.hcadUrl && activeEnvironment.hcadUrl.length > 0)"
                class="dropdown-divider"
              ></div>
            </div>
            <navbar-link v-if="canManageGames || canManageGameInvites" href="/blade/games" target="_blank" class="dropdown-item">Gamulations</navbar-link>
            <navbar-link v-if="canManageEnvironments" href="/blade/environments" target="_blank" class="dropdown-item">Gamulation Brandings</navbar-link>
            <div v-if="canManageGames">
              <navbar-link href="/blade/challenges" target="_blank" class="dropdown-item">Sections</navbar-link>
              <navbar-link href="/blade/event-pools" target="_blank" class="dropdown-item">Event Pools</navbar-link>
              <navbar-link href="/blade/major-decisions" target="_blank" class="dropdown-item">Major Decisions</navbar-link>
              <navbar-link href="/blade/minor-decisions" target="_blank" class="dropdown-item">Minor Decisions</navbar-link>
              <navbar-link href="/blade/outros" target="_blank" class="dropdown-item">Endgame Settings</navbar-link>
              <div class="dropdown-divider"></div>
              <navbar-link href="/blade/character-tree" target="_blank" class="dropdown-item">Character Explorer</navbar-link>
              <navbar-link href="/blade/characters" target="_blank" class="dropdown-item">Characters</navbar-link>
              <navbar-link href="/blade/roles" target="_blank" class="dropdown-item">Roles</navbar-link>
              <navbar-link href="/blade/metrics" target="_blank" class="dropdown-item">Metrics</navbar-link>
            </div>
            <!-- <div v-if="isOwnerAdminOrProfessor">
              <navbar-link href="/blade/classes" target="_blank" class="dropdown-item">{{classTypeNamePlural}}</navbar-link>
            </div>
            <div v-if="canManageUsers">
              <navbar-link v-if="canManageAllGroups" href="/blade/groups" target="_blank" class="dropdown-item">Groups</navbar-link>
              <navbar-link href="/blade/users" target="_blank" class="dropdown-item">Users</navbar-link>
              <navbar-link href="/blade/registration-links" target="_blank" class="dropdown-item">Registration Links</navbar-link>
              <navbar-link href="/blade/coupons" target="_blank" class="dropdown-item">Coupons</navbar-link>
            </div> -->
            <div
              v-if="(canManageGames || canManageGameInvites || canManageEnvironments)
                && (canManageUsers || canManageAllGroups || canManageGameSets || canManageDashboards || canGenerateReports
                  || (canViewDashboards && activeEnvironment.hcadUrl && activeEnvironment.hcadUrl.length > 0))"
              class="dropdown-divider"
            />
            <navbar-link v-if="canManageUsers" href="/blade/users" target="_blank" class="dropdown-item">Users</navbar-link>
            <navbar-link v-if="canManageClasses || isOwnerAdminOrProfessor" href="/blade/classes" target="_blank" class="dropdown-item">{{classTypeNamePlural}}</navbar-link>
            <navbar-link v-if="canManageAllGroups" href="/blade/playthroughs" target="_blank" class="dropdown-item">Playthroughs</navbar-link>
            <navbar-link v-if="canManageUsers" href="/blade/registration-links" target="_blank" class="dropdown-item">Registration Links</navbar-link>
            <navbar-link v-if="canManageGameSets" href="/blade/gamesets" target="_blank" class="dropdown-item">Gamulation Sets</navbar-link>
            <navbar-link v-if="canManageUsers" href="/blade/coupons" target="_blank" class="dropdown-item">Coupons</navbar-link>
            <navbar-link v-if="canManageUsers" href="/blade/article-categories" target="_blank" class="dropdown-item">Support Categories</navbar-link>
            <navbar-link v-if="canManageUsers" href="/blade/articles" target="_blank" class="dropdown-item">Support Articles</navbar-link>
            <div
              v-if="(canManageUsers || canManageAllGroups || canManageGameSets || isManager)
                && (canManageDashboards || canGenerateReports
                  || (canViewDashboards && activeEnvironment.hcadUrl && activeEnvironment.hcadUrl.length > 0))
              "
              class="dropdown-divider"
            ></div>
            <navbar-link v-if="canManageDashboards" href="/blade/dashboards/profiles" target="_blank" class="dropdown-item">Dashboard Profiles</navbar-link>
            <navbar-link v-if="canViewDashboards && activeEnvironment.hcadUrl && activeEnvironment.hcadUrl.length > 0"
              always-a
              :href="hcadUrl()"
              @click="clickHcadUrl"
              class="dropdown-item">Dashboards</navbar-link>
            <navbar-link v-if="canGenerateReports"
              href="/blade/usageData"
              target="_blank"
              class="dropdown-item">Reports</navbar-link>
          </div>
        </li>
        <template v-if="shouldDisplayCorporateSite">
          <li v-if="!hasAuthToken">
            <div class="navbar-item-divider"/>
          </li>
          <li v-if="!hasAuthToken" class="nav-item active">
            <a :href="corporateSiteUrl" target="_blank" class="nav-link"><span style="text-transform: none;" v-html="corporateSiteText"></span></a>
          </li>
        </template>
        <template v-if="shouldDisplayHelp">
          <li v-if="showInternalHelp || (!useInternalHelp && (activeEnvironment == null || activeEnvironment.name == null || !!(helpUrl)))">
            <div class="navbar-item-divider"/>
          </li>
          <support-ticket-input v-if="showInternalHelp" />
          <li v-else-if="!useInternalHelp && (activeEnvironment == null || activeEnvironment.name == null || !!(helpUrl))" class="nav-item active">
            <a
              :href="helpUrl || 'https://redmeru.zendesk.com'"
              target="_blank"
              class="nav-link"
              @click="helpClickTracker"
            >
              contact support
            </a>
          </li>
        </template>
        <template v-if="shouldDisplayFAQ">
          <li v-if="useInternalFaq || activeEnvironment == null || activeEnvironment.name == null || !!(faqUrl)">
            <div class="navbar-item-divider"/>
          </li>
          <support-article-viewer-modal v-if="useInternalFaq" />
          <li v-else-if="activeEnvironment == null || activeEnvironment.name == null || !!(faqUrl)" class="nav-item active">
            <a
              :href="faqUrl || 'https://redmeru.zendesk.com'"
              target="_blank"
              class="nav-link"
              @click="helpClickTracker"
            >
              <span style="text-transform: uppercase;">help</span>
            </a>
          </li>
          <li>
            <div class="navbar-item-divider"/>
          </li>
        </template>
        <template v-if="isAnonymousSignIn || qualtricsExitURL">
          <li v-if="hasAuthToken && !this.me.registrationLinkUsed.disableCancelSurveyButton" class="nav-item active">
            <a
              v-if="qualtricsExitURL"
              class="btn survey-exit-btn bg-danger"
              :href="qualtricsExitURL"
              role="button">
              {{cancelSurveyButtonText}}
            </a>
            <b-btn
              v-else
              class="btn survey-exit-btn bg-danger"
              @click="onLogout"
              role="button">
              {{cancelSurveyButtonText}}
            </b-btn>
          </li>
        </template>
        <template v-else>
          <li v-if="hasAuthToken && !isLti" class="nav-item dropdown active">
            <a
              class="nav-link dropdown-toggle username"
              href="#"
              id="accountMenu"
              role="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false">
              {{ usernameTruncated }}
            </a>
            <div class="dropdown-menu dropdown-menu-right navbar-bg" aria-labelledby="accountMenu">
              <template v-if="showAccountSettings">
                <a href="/user/edit" target="_blank" class="dropdown-item">Account Settings</a>
                <div class="dropdown-divider"/>
              </template>
              <template v-if="showAccountSettings">
                <a href="#" class="dropdown-item" @click="() => { showGameSettings = true; }">Audio Settings</a>
                <div class="dropdown-divider"/>
              </template>

              <a href="" class="dropdown-item" @click.prevent="onLogout">Log Out</a>
            </div>
          </li>
        </template>
      </ul>
    </div>
  </nav>
  <game-launcher v-if="showGameLauncher" @input="onGameSelected"></game-launcher>
  <game-settings v-if="showGameSettings" @close="() => { showGameSettings = false; }"></game-settings>
</header>
</template>

<script>
import Vue from 'vue';
import {
  mapActions,
  mapGetters,
  mapMutations
} from 'vuex';

import { brand } from '../assets/brand.json';
import GameLauncher from './ui/modals/GameLauncher';
import GameSettings from './ui/modals/GameSettings';
import SelectInput from './ui/inputs/SelectInput';
import ActiveAssetEnvironmentSelector from './ui/display/ActiveAssetEnvironmentSelector';
import SaveStateSelector from './ui/display/SaveStateSelector';
import SupportTicketInput from './ui/display/SupportTicketInput';
import SupportArticleViewerModal from './ui/display/SupportArticleViewerModal';
import NavbarLink from './ui/display/NavbarLink';
import isInIframe from '../utils/iframe';

export default {
  components: {
    NavbarLink,
    GameLauncher,
    GameSettings,
    SelectInput,
    ActiveAssetEnvironmentSelector,
    SaveStateSelector,
    SupportTicketInput,
    SupportArticleViewerModal,
  },
  data() {
    return {
      authFlip: false,
      brand,
      unwatch: null,
      showGameLauncher: false,
      forceCenteredTitle: false,
      nameTruncationLimit: 21,
      showGameSettings: false,
    };
  },
  computed: {
    ...mapGetters([
      'dashboardInstanceBaseURL',
      'activeDashboardLink',
      'activeEnvironment',
      'activeSignInConfig',
      'canViewDemo',
      'demo',
      'authToken',
      'hasAuthToken',
      'canSelectGame',
      'canRestartGame',
      'canManageDashboards',
      'canManageGames',
      'canManageGameSets',
      'canManageGameInvites',
      'canManageEnvironments',
      'canViewDashboards',
      'canManageUsers',
      'canManageClasses',
      'canGenerateReports',
      'canManageAllGroups',
      'canUseSaveStates',
      'dashboardsEnabled',
      'isOwnerOrAdmin',
      'me',
      'showAdmin',
      'zoom',
      'isStudent',
      'isProfessor',
      'isManager',
      'isOwnerAdminOrProfessor',
      'activeToggleSettings',
      'isLti',
      'hasAnonymousIdParam',
      'classTypeNamePlural',
      'cachedActiveGameSetGames'
    ]),
    cancelSurveyButtonText() {
      if (this.me.registrationLinkUsed && this.me.registrationLinkUsed.cancelSurveyButtonText) {
        return this.me.registrationLinkUsed.cancelSurveyButtonText;
      }
      return 'I no longer want to take this survey';
    },
    isAnonymousSignIn() {
      return this.hasAnonymousIdParam
        || (this.activeSignInConfig && this.activeSignInConfig.uniqueIdSignin)
        || (this.me && this.me.registrationLinkUsed && this.me.registrationLinkUsed.uniqueIdSignin);
    },
    shouldDisplayDashboardLink() {
      console.log(this.activeEnvironment);
      return this.dashboardsEnabled && this.canViewDashboards && this.activeDashboardLink;
    },
    shouldDisplayHubButton() {
      return !this.isLti && this.me
        && (this.canRestartGame || this.canSelectGame
          || (
            ((this.cachedActiveGameSetGames && this.cachedActiveGameSetGames.length)
              ? this.cachedActiveGameSetGames.length
              : (this.me.assignedGame ? this.me.assignedGame.length : 0))
            + (this.me.classes ? this.me.classes.length : 0)
            > 1
          )
        )
        // && (!this.isGameRoute || (this.$route.meta && this.$route.meta.showHubButton))
        && (this.authFlip || !this.authFlip);
    },
    showAccountSettings() {
      // If the email includes an '@', allow the user to modify their account settings.
      // This is specifically to address the case of PROLID code users, who should not be
      // able to modify their account settings.  A more robust system for this may be warranted
      // later.
      const {
        email = ''
      } = this.me || {};
      return email.includes('@');
    },
    shouldOpenInNewTab() {
      return this.isDemoOrGameRoute || this.isHubRoute || this.isLti;
    },
    shouldDisplayAssetEnvironmentSelector() {
      if (!this.$route.path.includes('/blade/')) return false;
      return (this.canManageGames) && this.showAdmin;
    },
    shouldDisplaySupportTicketInput() {
      return this.canManageUsers;
    },
    shouldDisplaySaveStateSelector() {
      if (this.$route.path.includes('/blade/')) return false;
      return (this.canUseSaveStates) && this.showAdmin;
    },
    shouldUseSignInSettings() {
      return !(this.$route.meta && this.$route.meta.doNotUseSignInForNavbar)
        && ((this.$route.meta && this.$route.meta.useSignInForNavbar)
          || !(this.$route.path.startsWith('/groups/')));
    },
    navbarLogo() {
      if (this.shouldUseSignInSettings) {
        const config = this.activeSignInConfig;
        if (config && config.navbarLogo && config.navbarLogo !== '') {
          return config.navbarLogo;
        }
      }
      // TODO: Update the fallback
      return this.activeEnvironment.titleLogo || 'https://assets.redmeru.com/eai/blade_logos/BLADE-FullWordmark-dark.jpg';
    },
    useInternalHelp() {
      if (this.shouldUseSignInSettings) {
        const config = this.activeSignInConfig;
        if (config) {
          return config.useInternalHelp;
        }
      }
      return this.activeEnvironment.useInternalHelp;
    },
    showInternalHelp() {
      if (this.shouldUseSignInSettings) {
        const config = this.activeSignInConfig;
        if (config) {
          return config.useInternalHelp && !(config.hideHelpFromNavbar);
        }
      }
      return this.activeEnvironment.useInternalHelp && !(this.activeEnvironment.hideHelpFromNavbar);
    },
    useInternalFaq() {
      if (this.shouldUseSignInSettings) {
        const config = this.activeSignInConfig;
        if (config) {
          return config.useInternalFaq;
        }
      }
      return this.activeEnvironment.useInternalFaq;
    },
    helpUrl() {
      if (this.shouldUseSignInSettings) {
        const config = this.activeSignInConfig;
        if (config && config.helpUrl && config.helpUrl !== '') {
          return config.helpUrl;
        }
      }
      return this.activeEnvironment.helpUrl;
    },
    faqUrl() {
      if (this.shouldUseSignInSettings) {
        const config = this.activeSignInConfig;
        if (config && config.faqUrl && config.faqUrl !== '') {
          return config.faqUrl;
        }
      }
      return this.activeEnvironment.faqUrl;
    },
    corporateSiteUrl() {
      if (this.shouldUseSignInSettings) {
        const config = this.activeSignInConfig;
        if (config && config.corporateSiteUrl && config.corporateSiteUrl !== '') {
          return config.corporateSiteUrl;
        }
      }
      return 'https://www.redmerproductions.com/redmeru';
    },
    corporateSiteText() {
      if (this.shouldUseSignInSettings) {
        const config = this.activeSignInConfig;
        if (config && config.corporateSiteText && config.corporateSiteText !== '') {
          return config.corporateSiteText;
        }
      }
      return 'corporate site';
    },
    shouldDisplayCorporateSite() {
      // TODO: Read from environment if not in sign in
      if (!this.shouldUseSignInSettings) return true;
      const settings = this.activeToggleSettings;
      return !settings || settings.displayCorporateSite;
    },
    shouldDisplayHelp() {
      // TODO: Read from environment if not in sign in
      if (!this.shouldUseSignInSettings) return true;
      const settings = this.activeToggleSettings;
      return !settings || settings.displayHelp;
    },
    shouldDisplayFAQ() {
      // TODO: Read from environment if not in sign in
      if (!this.shouldUseSignInSettings) return true;
      const settings = this.activeToggleSettings;
      return !settings || settings.displayFAQ;
    },
    restartableGames() {
      const {
        assignedGame = [],
      } = this.me || {};
      return assignedGame;
    },
    classes() {
      const {
        classes = []
      } = this.me || {};
      return classes;
    },
    qualtricsExitURL() {
      let url = this.activeSignInConfig.qualtricsExitURL
            || (this.me.registrationLinkUsed ? this.me.registrationLinkUsed.qualtricsExitURL : undefined);
      if (!url || !url.trim()) { return null; }
      // This is hardcoded for now, but we could definitely make it a bit more flexible
      if (url.includes('?')) {
        url += `&aid=${this.me.email}`;
      } else {
        url += `?aid=${this.me.email}`;
      }
      return url;
    },
    username() {
      const {
        firstName = '',
        lastName = '',
        email = ''
      } = this.me || {};
      return firstName || lastName ? `${firstName} ${lastName}` : email;
    },
    usernameTruncated() {
      return this.username.length > this.nameTruncationLimit
        ? `${this.username.substring(0, this.nameTruncationLimit)}...` : this.username;
    },
    headerHasChanged() {
      return [
        this.hasAuthToken,
        this.canViewDemo,
        this.canRestartGame,
        this.canSelectGame,
        this.canManageGames,
        this.canManageGameInvites,
        this.canManageEnvironments,
        this.canManageUsers,
        this.demo,
        this.isDemoRoute,
        this.isGameRoute,
        this.canGenerateReports,
      // eslint-disable-next-line no-bitwise
      ].reduce((acc, flag, i) => acc + (flag ? 1 << i : 0), 0);
    },
    isDemoRoute() {
      return this.$route.path.startsWith('/demo');
    },
    isGameRoute() {
      return this.$route.path.startsWith('/groups');
    },
    isHubRoute() {
      return this.$route.path.startsWith('/hub');
    },
    isDemoOrGameRoute() {
      return this.isDemoRoute || this.isGameRoute;
    }
  },
  methods: {
    ...mapActions([
      'exitDemo',
      'getMyGroup',
      'logout',
      'setHeaderHeight',
      'flashDanger',
      'helpClickTracker',
      'getActiveEnvironment',
      'getActiveGameSetGames'
    ]),
    ...mapMutations([
      'setActiveEnvironment',
      'setAudioPause',
    ]),
    hcadUrl() {
      let base = this.activeEnvironment.hcadUrl || this.dashboardInstanceBaseURL;
      const hashIdx = base.indexOf('#');
      if (hashIdx > -1) {
        base = `${base.substring(0, hashIdx - 1)
        }?token=${encodeURIComponent(this.authToken)}&tabtext=${encodeURIComponent(document.title)}${
          base.substring(hashIdx)}`;
      } else {
        base += `?token=${encodeURIComponent(this.authToken)}&tabtext=${encodeURIComponent(document.title)}`;
      }
      return base;
    },
    clickHcadUrl() {
      window.open(this.hcadUrl(), '_blank').focus();
    },
    computeStyle(to, from = null) {
      if (to && from && to.meta && from.meta &&
          to.meta.useSignInForNavbar === from.meta.useSignInForNavbar) {
        return;
      }

      if (to.meta && to.meta.useSignInForNavbar) {
        const signinConfig = this.activeSignInConfig;
        if (signinConfig.environment) {
          this.setActiveEnvironment(signinConfig.environment);
        }
        if (signinConfig.tabText) {
          document.title = signinConfig.tabText;
        }
      } else {
        const environment = this.activeEnvironment;
        if (environment.tabText) {
          document.title = environment.tabText;
        }
        this.getActiveEnvironment({ path: (from ? from.path : this.$route.path) });
      }
    },
    onLogout() {
      this.logout();
      this.exitDemo();
      this.$router.replace('/signin');
      this.$router.go(0);
    },
    onExitDemo() {
      this.exitDemo();
      this.$router.home();
    },
    async restartDemo() {
      if (!this.canRestartGame || this.showGameLauncher) return;

      this.showGameLauncher = true;
    },
    async onGameSelected() {
      this.showGameLauncher = false;
    },
    toggleFullscreen() {
      const doc = window.document;
      const docEl = doc.documentElement;

      const requestFullscreen =
        docEl.requestFullscreen
          || docEl.mozRequestFullScreen
          || docEl.webkitRequestFullScreen
          || docEl.msRequestFullscreen;
      const cancelFullscreen =
        doc.exitFullscreen
          || doc.mozCancelFullScreen
          || doc.webkitExitFullscreen
          || doc.msExitFullscreen;

      if (!doc.fullscreenElement
        && !doc.mozFullScreenElement
        && !doc.webkitFullscreenElement
        && !doc.msFullscreenElement) {
        requestFullscreen.call(docEl);
      } else {
        cancelFullscreen.call(doc);
      }
    },
    onClickBrand() {
      this.setAudioPause(true);
      // this.exitDemo();
      // this.$router.home();
      // this.$router.go(0);
      if (this.$route.meta.forceFirstRoute) {
        if (this.$route.path === '/helpcenter') {
          const newQueryParams = Object.assign({}, this.$route.query);
          newQueryParams.cat = undefined;
          newQueryParams.article = undefined;
          this.$router.push({ path: this.$route.path, query: newQueryParams });
        } else {
          this.$router.go(0);
        }
      } else {
        this.$router.push('/hub');
      }
    },
    handleResize() {
      if (this.me) {
        if (this.me.roles) {
          this.forceCenteredTitle =
            isInIframe()
              || (document.documentElement.clientWidth > 1400 && !this.canUseSaveStates)
              || (this.$refs.navbarRoot && this.$refs.navbarRoot.clientWidth < 992);
          if (document.documentElement.clientWidth <= 1400) {
            this.nameTruncationLimit = 26;
          } else {
            this.nameTruncationLimit =
              17 + Math.floor((document.documentElement.clientWidth - 1400) / 35);
          }
        } else {
          setTimeout(this.handleResize, 100);
        }
      }
    },
    async toggleNavbar() {
      if (window.location.href.endsWith('#navbar')) {
        history.go(-1);
      } else {
        setTimeout(() => {
          // console.log(this.$refs.togglee.classList);
          if (this.$refs.togglee
            && this.$refs.togglee.classList.contains('collapse')
            && this.$refs.togglee.classList.contains('show')) {
            history.pushState({}, null, '#navbar');
          }
        }, 400);
      }
      const totalTimeMS = 350;
      const stepMS = 10;
      let timeMS = 0;
      const toggleInterval = setInterval(() => {
        if (timeMS > totalTimeMS) return clearInterval(toggleInterval);
        this.exportHeaderHeight();
        timeMS += stepMS;
      }, stepMS);

      await new Promise(resolve => setTimeout(resolve, 1000));
      this.exportHeaderHeight();
    },
    exportHeaderHeight() {
      const [headerChild = {}] = this.$refs.header.children;
      const { offsetHeight: headerHeight } = headerChild;
      this.setHeaderHeight({ headerHeight });
    }
  },

  async created() {
    this.getActiveGameSetGames();
  },

  async mounted() {
    this.unwatch = this.$store.subscribe((mutation) => {
      if (mutation.type === 'setAuthToken') {
        this.$nextTick(() => {
          this.getActiveGameSetGames(true);
          this.authFlip = !this.authFlip;
        });
      }

      if (mutation.type === 'setActiveSignInConfig') {
        const newconfig = this.activeSignInConfig;
        if (newconfig.environment) {
          this.setActiveEnvironment(newconfig.environment);
        }
      }

      if (mutation.type === 'setActiveEnvironment' || mutation.type === 'setActiveSignInConfig') {
        if (this.activeSignInConfig.tabText && this.activeSignInConfig.tabText !== '') {
          this.$nextTick(() => {
            if (this.$route.path === '/signin') {
              document.title = this.activeSignInConfig.tabText;
            }
          });
        }
      }
    });

    addEventListener('popstate', () => {
      // console.log(this.$refs.togglee.classList);
      if (this.$refs.togglee
        && this.$refs.togglee.classList.contains('collapse')
        && this.$refs.togglee.classList.contains('show')) {
        this.$refs.toggler.click();
      }
    });

    this.handleResize();
    window.addEventListener('resize', this.handleResize);

    this.computeStyle(this.$route);
  },
  beforeDestroy() {
    this.unwatch();
    window.removeEventListener('resize', this.handleResize);
  },
  watch: {
    $route(to, from) {
      this.computeStyle(to, from);
    },
    async headerHasChanged() {
      await Vue.nextTick();
      this.exportHeaderHeight();
    }
  }
};
</script>

<style lang="scss" scoped>
header {
  height: 40px;
  width: 100%;
}

.navbar-root {
  z-index: 10001;
  width: 100%;
  height: 100%;
  padding-top: 4px;
  justify-content: space-between;

  .nav-link {
    color: var(--navBarTextColor) !important;
    margin: 0 2px;
    // font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    text-transform: lowercase;
    font-weight: 100;
  }
  .nav-link:hover {
    // background-color: rgba(0, 0, 7, 0.2);
    background-color: var(--navBarHoverColor);
  }

  .dropdown-item {
    color: var(--navBarTextColor) !important;
    // font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    text-transform: lowercase;
    font-weight: 100;
  }
  .dropdown-item:hover {
    // background-color: rgba(0, 0, 7, 0.4);
    background-color: var(--navBarHoverColor);
  }

  .dropdown-divider {
    border-color: var(--primaryColor);
  }

  .username {
    text-transform: unset !important;
  }
}

.navbar-bg {
  // background-color: rgba(0, 0, 7, 0.76);
  background-color: var(--navBarDropdownColor);
}

.navbar-logo {
  height: 100%;
  position: relative;
  flex-shrink: 1;
  flex-grow: 10;
  flex-basis: 0;
}
.navbar-logo.centered-title {
  flex-grow: 0 !important;
  flex-shrink: 0 !important;
  flex-basis: 33% !important;
  width: 33% !important;
}
.logo-link {
  outline-color: white;
  height: 100%;
  padding: 0 6px 2px;
}
.logo {
  height: 100%;
  max-width: 100%;
  object-fit: contain;
}
.navbar-brandText {
  flex-shrink: 1;
  flex-grow: 25;
  flex-basis: 0;
  padding: 0 5px;
  color: var(--navBarTextColor);
  outline-color: white;
  width: auto;
  margin: auto 0;
  text-align: center;
  white-space: nowrap;
  font-size: calc(max(14.419px,min(16pt, 1.45vw)));
  font-weight: bold;
  font-family: unset;
  // font-weight: normal;
  // font-family: "Book Antiqua", Palatino, serif;
  // justify-self: center;
  // align-self: center;
}
.navbar-brandText.centered-title {
  flex-grow: 0 !important;
  flex-shrink: 0 !important;
  flex-basis: 33% !important;
  width: 33% !important;
}
.noselect {
  -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
     -khtml-user-select: none; /* Konqueror HTML */
       -moz-user-select: none; /* Old versions of Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
            user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
}
.navbar-actionItems {
  // width: 50%;
  // height: auto;
  // display: flex;
  // flex-direction: row;
  // justify-content: flex-end;
  background-color: var(--navBarColor);
  z-index: 1000;
  border-radius: 8px;
  white-space: nowrap;
  // flex-shrink: 1;
  // flex-basis: 0;
}
.navbar-actionItems.centered-title:not(.collapse):not(.collapsing) {
  flex-grow: 0 !important;
  flex-shrink: 0 !important;
  flex-basis: 33% !important;
  width: 33% !important;
  background-color: transparent !important;
}

.navbar-brand:focus, .nav-item a:focus {
  outline-color: white;
}

.nav-item {
  line-height: 120%;
}

.title {
  color: var(--primaryColor);
  background-color: white;
  font-size: 72px;
  font-weight: bold;
  border-radius: 0;
  margin: 0;
  padding: 40px;
}
.demo-links {
  display: flex;
  flex-flow: row;
  justify-content: flex-end;
}
.demo-link {
  color: black;
  padding: 2px 5px;
}
.demo-link:hover, .demo-link:focus {
  text-decoration: none;
  color: var(--primaryColor);
}
.demo-link:focus {
  outline: none;
}

.dropdown-toggle[aria-expanded="true"]:after {
  transform: rotate(180deg);
}
.dropdown-toggle:after {
  transition: 0.4s;
}

.navbar-item-divider {
  //width: 1.3px;
  //background-color: var(--primaryColor);
  // Doing it with border rather than width because borders tend to render thin lines more cleanly
  // across different browsers
  height: 72%;
  width: 0px;
  margin: 5px 4px;
  border-right: 1px solid var(--primaryColor);
}

.survey-exit-btn {
  // From nav-link
  margin: 2px 2px 0px 0px;
  padding-left: 10px;
  padding-right: 10px;
  border: none !important;
  box-shadow: none !important;
  -webkit-box-shadow: none !important;

  color: white !important;
  font-weight: 800 !important;
  font-size: 16px;

  // background-color: red;
  background-image: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Navbar.vue